import React, { useEffect, useState } from "react";
import {
  Modal,
  Button,
  Menu,
  Dropdown,
  Radio,
  Input,
  Space,
  Alert,
  Tooltip,
  Spin,
} from "antd";
import { DownOutlined } from "@ant-design/icons";
import TagsInputs from "../InputTags";
import Profile from "../../../../assets/Sidebar/Profile_Pic.svg";
import BackArrow from "../../../../assets/BackArrow.svg";

import {
  getShareableId,
  setSharableId,
  setShareableModifyUserData,
  setDefaultSharableUserData,
} from "../../../../redux/actions/ApiCall/apiCall";
import { useDispatch, useSelector } from "react-redux";
import Brand from "../../../layout/WelcomePage/Template/Brand";
import logoLoc from "../../../../assets/Locobuzz_logo.png";
import accoArrow from "../../../../assets/acco_arrow-up.svg";
import accoArrowWhite from "../../../../assets/WhiteIcons/acco_arrow-upWhite.svg";
import { setGraphPageBrandValue } from "../../../../redux/actions/Template";
import { setSharedBrands } from "../../../../redux/actions/share/Share";
import ShareDropdown from "./ShareDropdown";
import {
  getPaneIndex,
  callNotification,
  getTemplateListBasicObject,
} from "../../../../redux/constants";
import { memo } from "react";

const { TextArea } = Input;

const SendModal = ({
  isModalShare,
  handleChangeShare,
  selectedUserId,
  setSelectedUserId,
  setDeselectId,
  selectedUserData,
  shareMode,
}) => {
  const dispatch = useDispatch();
  const [shareAccount, setShareAccount] = useState(1);
  const [valuePassword, setValuePassword] = useState(1);
  const [shareableLink, setShareableLink] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const shareableData = useSelector((state) => state.dashboard.shareableData);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const shareableUrl = useSelector((state) => state.ApiCall.shareableLink);
  const sharedBrands = useSelector((state) => state.Share.sharedBrands);
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );

  const selectBrandValue = useSelector(
    (state) => state.Template.selectBrandValue
  ); // selected brand values
  const brandCheckedItems = useSelector(
    (state) => state.Template.brandCheckedItems
  ); //checked brand values
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);

  const defaultShareableUserData = useSelector(
    (state) => state.ApiCall.defaultShareableUserData
  );

  const shareableUserData = useSelector(
    (state) => state.ApiCall.shareableUserData
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );

  const [sendModifyData, setSendModifyData] = useState([]);
  let index = getPaneIndex(panes, activeKey);

  const templateName = panes[index].template_name;
  const [message, setMessage] = useState();
  const [emptyError, setEmptyError] = useState(false);
  const [messageError, setMessageError] = useState();

  const getWindowSize = () => {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  };

  const getPageSize = (windowSize) => {
    let currentWindowSize = windowSize?.innerWidth;

    if (currentWindowSize >= 2261) {
      return 21;
    } else if (currentWindowSize < 2261 && currentWindowSize >= 1905) {
      return 18;
    } else if (currentWindowSize < 1905 && currentWindowSize >= 1590) {
      return 15;
    } else if (currentWindowSize < 1590 && currentWindowSize >= 1278) {
      return 12;
    } else if (currentWindowSize < 1278 && currentWindowSize >= 966) {
      return 12;
    } else if (currentWindowSize < 966) {
      return 10;
    }
    return 12;
  };

  const [windowWidths, setWindowWidths] = useState(null);
  const [windowSize, setWindowSize] = useState(getWindowSize());
  const [pageSize, setPageSize] = useState(getPageSize(windowSize));

  useEffect(() => {
    if (shareableUrl) {
      setIsLoading(false);
      setShareableLink(true);
    }
  }, [shareableUrl]);

  useEffect(() => {
    if (selectedUserId == "all") {
      let allArrayData = shareableUserData.map((s) => {
        return { user_id: s.user_id, access_type: 1 };
      });
      setSendModifyData(allArrayData);
    } else {
      let newArray = selectedUserId.map((s) => {
        return { user_id: s, access_type: 1 };
      });
      setSendModifyData(newArray);
    }
  }, [selectedUserId]);

  const onChangeradio = (e) => {
    setValuePassword(e.target.value);
  };

  const handleOk = () => {
    handleChangeShare(false);
  };
  const handleCancel = () => {
    handleChangeShare(false);
    dispatch(setSharableId(null));
    dispatch(setSharedBrands(null));
    let brandsObject = {
      type: "share_modal",
      brands: brands,
      selectBrandValue: selectBrandValue,
      brandCheckedItems: brandCheckedItems,
    };
    dispatch(setGraphPageBrandValue(brandsObject));
  };

  const handleShareFeature = (e) => {
    setShareAccount(e.target.value);
    if (selectedUserId == "all") {
      let allArrayData = shareableUserData.map((s) => {
        return { user_id: s.user_id, access_type: e.target.value };
      });
      setSendModifyData(allArrayData);
    } else {
      let newArray = selectedUserId?.map((s) => {
        return { user_id: s, access_type: e.target.value };
      });
      setSendModifyData(newArray);
    }
  };

  const handleSubmitSendModal = () => {
    let emptyListError = false;
    if (!sendModifyData || sendModifyData?.length === 0) {
      emptyListError = true;
    } else {
      emptyListError = false;
    }
    setEmptyError(emptyListError);
    if (!emptyListError) {
      let index = getPaneIndex(panes, activeKey);
      let template_id = shareableData?.template_id
        ? shareableData?.template_id
        : panes?.[index]?.template_id;

      let newData = {
        template_id: template_id,
        data: sendModifyData,
        // message: message,
      };

      let basicObj = getTemplateListBasicObject(
        authParams,
        panes,
        index,
        pageSize,
        graphConditionConfig
      );

      let paneObject = {
        panes: panes,
        activeKey: activeKey,
        type: window.location.pathname === "/schedule" ? "report" : "dashboard",
        edited_dashboard_flow: panes?.[index]?.allow_restore
          ? panes?.[index]?.allow_restore
          : false,
      };
      dispatch(
        setShareableModifyUserData(
          basicObj,
          newData,
          "added",
          paneObject,
          shareMode === "all" ? 1 : 0,
          null // no separate access_type for individual adds
        )
      );
      handleChangeShare(false);
      dispatch(setDefaultSharableUserData());
    }
  };

  const onIncludeTagsChanged = (tags) => {};

  const handleShare = () => {
    setIsLoading(true);
    authParams &&
      dispatch(
        getShareableId(
          shareableData?.template_id,
          authParams,
          sharedBrands?.columns ? sharedBrands?.columns : panes[index]?.brands,
          "share_id",
          brands
        )
      );
  };

  const handleMessage = (e) => {
    let text = e.target.value;

    if (text.length <= 0) {
      setEmptyError(true);
    } else {
      setEmptyError(false);
    }

    if (text.length > 150) {
      setMessageError(true);
    } else {
      setMessageError(false);
    }
    setMessage(text);
  };

  const menu = (
    <Menu className="text_regular">
      <Menu.Item className="text_regular font-size14">
        <Radio.Group onChange={handleShareFeature} defaultValue={shareAccount}>
          <Space direction="vertical">
            <Radio className="text_regular font-size14" value={1}>
              View Only
            </Radio>
            <Radio className="text_regular font-size14" value={2}>
              Editor
            </Radio>
          </Space>
        </Radio.Group>
      </Menu.Item>
    </Menu>
  );

  return (
    <div className="bg__white" style={{ borderRadius: "0 0 0.4rem 0.4rem" }}>
      <div className="w-100" style={{ padding: "1.5rem 2rem 0" }}>
        <label className="portlet-label font-weight500">
          Share With Team Members
        </label>
        <div className="d-flex align-items-start mb-15 justify-content-between">
          <ShareDropdown
            selectedUserId={selectedUserId}
            setSelectedUserId={setSelectedUserId}
            setDeselectId={setDeselectId}
          />
          <Dropdown
            overlayClassName={
              authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
            }
            overlay={menu}
            trigger={["click"]}
            placement="bottomRight"
          >
            <div
              className="ml-15 text_regular d-flex align-items-center justify-content-between cursor-pointer sharable-link-access-type-button"
              onClick={(e) => e.preventDefault()}
              style={{ padding: "0.8rem 1rem", height: "4.2rem" }}
            >
              {shareAccount === 1 ? "View Only" : "Editor"}
              <img
                src={
                  authParams?.theme_type === "1" ? accoArrowWhite : accoArrow
                }
                alt="Arrow"
                className="accordionArrow p-0"
              />
            </div>
          </Dropdown>
        </div>
        {emptyError && (
          <div className="mb-15" style={{ color: "red" }}>
            Please select at least one account.
          </div>
        )}
        {/* <div className="from-group floating-label-group mb-15">
          <TextArea
            rows={5}
            onChange={handleMessage}
            className="border-color border-radius-4 pt-10"
            style={{ resize: "none" }}
          />
          <label className="portlet-label floating-label">
            Write Message <span className="error">*</span>
          </label>
          {emptyError && (
            <span style={{ color: "red" }}>Message can not be empty</span>
          )}
          {messageError && (
            <span style={{ color: "red" }}>
              Message should be less than 150 characters
            </span>
          )}
        </div> */}
      </div>
      <div
        className="text-right bg__white border-top border-color p-15 mb-15"
        style={{ borderRadius: "0 0 0.4rem 0.4rem" }}
      >
        <div style={{ float: "left" }} className="share-link-temp-name">
          <Tooltip title={templateName} color="#3B5175">
            <p className="share-link-temp-name-text">
              <svg
                width="20"
                height="20"
                viewBox="0 0 64 64"
                style={{ marginRight: "1rem" }}
              >
                <defs>
                  <clipPath id="clip-path">
                    <circle
                      id="Ellipse_3607"
                      data-name="Ellipse 3607"
                      cx="32"
                      cy="32"
                      r="32"
                      transform="translate(-0.046)"
                      fill="#fff"
                    ></circle>
                  </clipPath>
                </defs>
                <g
                  id="Group_22543"
                  data-name="Group 22543"
                  transform="translate(0.046)"
                >
                  <circle
                    id="Ellipse_3606"
                    data-name="Ellipse 3606"
                    cx="32"
                    cy="32"
                    r="32"
                    transform="translate(-0.046)"
                    fill="#0C8CC8"
                  ></circle>
                  <g id="Group_22543-2" data-name="Group 22543">
                    <g id="Group_21847" data-name="Group 21847">
                      <g
                        id="Mask_Group_21"
                        data-name="Mask Group 21"
                        opacity="0.5"
                        clip-path="url(#clip-path)"
                      >
                        <g
                          id="Group_21846"
                          data-name="Group 21846"
                          transform="translate(-5.717 -5.054)"
                          opacity="0.3"
                        >
                          <line
                            id="Line_6840"
                            data-name="Line 6840"
                            y2="75.107"
                            transform="translate(11.266)"
                            fill="none"
                            stroke="#fff"
                            stroke-width="1"
                          ></line>
                          <line
                            id="Line_6842"
                            data-name="Line 6842"
                            y2="75.107"
                            transform="translate(75.107 11.266) rotate(90)"
                            fill="none"
                            stroke="#fff"
                            stroke-width="1"
                          ></line>
                          <line
                            id="Line_6840-2"
                            data-name="Line 6840"
                            y2="75.107"
                            transform="translate(18.777)"
                            fill="none"
                            stroke="#fff"
                            stroke-width="1"
                          ></line>
                          <line
                            id="Line_6843"
                            data-name="Line 6843"
                            y2="75.107"
                            transform="translate(75.107 18.777) rotate(90)"
                            fill="none"
                            stroke="#fff"
                            stroke-width="1"
                          ></line>
                          <line
                            id="Line_6840-3"
                            data-name="Line 6840"
                            y2="75.107"
                            transform="translate(26.288)"
                            fill="none"
                            stroke="#fff"
                            stroke-width="1"
                          ></line>
                          <line
                            id="Line_6844"
                            data-name="Line 6844"
                            y2="75.107"
                            transform="translate(75.107 26.287) rotate(90)"
                            fill="none"
                            stroke="#fff"
                            stroke-width="1"
                          ></line>
                          <line
                            id="Line_6840-4"
                            data-name="Line 6840"
                            y2="75.107"
                            transform="translate(33.798)"
                            fill="none"
                            stroke="#fff"
                            stroke-width="1"
                          ></line>
                          <line
                            id="Line_6845"
                            data-name="Line 6845"
                            y2="75.107"
                            transform="translate(75.107 33.799) rotate(90)"
                            fill="none"
                            stroke="#fff"
                            stroke-width="1"
                          ></line>
                          <line
                            id="Line_6840-5"
                            data-name="Line 6840"
                            y2="75.107"
                            transform="translate(41.309)"
                            fill="none"
                            stroke="#fff"
                            stroke-width="1"
                          ></line>
                          <line
                            id="Line_6846"
                            data-name="Line 6846"
                            y2="75.107"
                            transform="translate(75.107 41.309) rotate(90)"
                            fill="none"
                            stroke="#fff"
                            stroke-width="1"
                          ></line>
                          <line
                            id="Line_6840-6"
                            data-name="Line 6840"
                            y2="75.107"
                            transform="translate(48.82)"
                            fill="none"
                            stroke="#fff"
                            stroke-width="1"
                          ></line>
                          <line
                            id="Line_6847"
                            data-name="Line 6847"
                            y2="75.107"
                            transform="translate(75.107 48.82) rotate(90)"
                            fill="none"
                            stroke="#fff"
                            stroke-width="1"
                          ></line>
                          <line
                            id="Line_6840-7"
                            data-name="Line 6840"
                            y2="75.107"
                            transform="translate(56.331)"
                            fill="none"
                            stroke="#fff"
                            stroke-width="1"
                          ></line>
                          <line
                            id="Line_6848"
                            data-name="Line 6848"
                            y2="75.107"
                            transform="translate(75.107 56.33) rotate(90)"
                            fill="none"
                            stroke="#fff"
                            stroke-width="1"
                          ></line>
                          <line
                            id="Line_6840-8"
                            data-name="Line 6840"
                            y2="75.107"
                            transform="translate(63.841)"
                            fill="none"
                            stroke="#fff"
                            stroke-width="1"
                          ></line>
                          <line
                            id="Line_6849"
                            data-name="Line 6849"
                            y2="75.107"
                            transform="translate(75.107 63.842) rotate(90)"
                            fill="none"
                            stroke="#fff"
                            stroke-width="1"
                          ></line>
                        </g>
                      </g>
                      <rect
                        id="Rectangle_10680"
                        data-name="Rectangle 10680"
                        width="8.5"
                        height="23.529"
                        transform="translate(42.637 20.735)"
                        fill="#fff"
                      ></rect>
                      <rect
                        id="Rectangle_10681"
                        data-name="Rectangle 10681"
                        width="8.5"
                        height="23.529"
                        transform="translate(12.637 20.735)"
                        fill="#fff"
                      ></rect>
                      <rect
                        id="Rectangle_10682"
                        data-name="Rectangle 10682"
                        width="8.5"
                        height="39"
                        transform="translate(27.637 13)"
                        fill="#fff"
                      ></rect>
                    </g>
                  </g>
                </g>
              </svg>
              {templateName.slice(0, 10) +
                (templateName.length > 10 ? "..." : "")}
            </p>
          </Tooltip>
        </div>
        <Button
          type="button"
          className="btn_Clear mr-15"
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          className="ant-btn-primary_blue"
          onClick={() => handleSubmitSendModal()}
        >
          Send
        </Button>
      </div>
    </div>
  );
};

export default memo(SendModal);
